<template>
  <div class="title-box">
    <div class="g-container">
      <h2 v-if="title.length>0" class="g-title title-box__title g-font-bold">{{ title }}</h2>
      <NouTab
        v-if="menus.length>0"
        class="title-box__tab"
        v-model="bindValue"
        :tabs="menus"
        @change="emitChange"
      >
      </NouTab>
      <slot />
    </div>
  </div>
</template>

<script>

export default {
  name: 'TitleBox',
  props: {
    title: {
      type: String,
      require: false,
      default: '',
    },
    menus: {
      type: Array,
      require: false,
      default() {
        return [];
      },
    },
    value: {
      type: [String, Number],
      require: false,
      default: '',
    },
  },
  computed: {
    bindValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    emitChange(val) {
      this.$emit('change', val);
    },
  },
};
</script>

<style lang="scss" scoped>
  .title-box {
    background: var(--background-common);
  }

  .title-box__title {
    padding-top: 20px;
    font-size: 32px;
    line-height: 40px;
  }

  .title-box__tab {
    margin-top: 20px;
  }
</style>
